<template>
  <div class="container-table-apps">
    <q-card>
      <q-card-section>
        <q-table
          data-cy="ambitos-table"
          :data="data"
          :columns="columns"
          row-key="id"
          selection="multiple"
          :pagination.sync="pagination"
          :loading="isLoading"
        >
          <template v-slot:header="props">
            <q-tr :props="props">
              <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ col.label }}
              </q-th>
            </q-tr>
          </template>
          <template v-slot:body="props">
            <q-tr
              :props="props"
              @click="triggerEdit(props.row)"
              style="cursor: pointer"
            >
              <q-td key="name" :props="props">
                {{ props.row.name }}
              </q-td>
              <q-td key="estado" :props="props">
                <q-toggle
                  color="primary"
                  v-model="props.row.visible"
                  @input="saveValue(props.row.visible, props.row)"
                />
              </q-td>
            </q-tr>
          </template>
        </q-table>
      </q-card-section>
    </q-card>
    <q-page-sticky position="bottom-right" :offset="[28, 28]">
      <q-btn
        data-cy="new-ambito"
        fab
        icon="add"
        title="Crear nuevo Ámbito"
        color="primary"
        @click="_createAmbito()"
      />
    </q-page-sticky>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import {
  QToggle,
  QTable,
  QTd,
  QTr,
  QTh,
  QCard,
  QCardSection,
  QPageSticky
} from 'quasar';

export default {
  components: {
    QToggle,
    QTable,
    QTd,
    QTr,
    QTh,
    QCard,
    QCardSection,
    QPageSticky
  },
  mixins: [Message],
  props: {
    dataGrupos: Array,
    isLoading: Boolean
  },
  computed: {},
  data () {
    return {
      pagination: {
        rowsPerPage: 20
      },
      data: this.dataGrupos,
      columns: [
        {
          name: 'name',
          label: 'Nombre',
          align: 'left',
          field: 'name',
          sortable: true
        },
        {
          name: 'estado',
          label: 'Estado',
          align: 'left',
          field: 'visible',
          sortable: true
        }
      ]
    };
  },
  methods: {
    triggerEdit (row) {
      this.$router.push({
        name: 'form_ambito',
        params: { idAmbito: row.id }
      });
    },
    async saveValue (value, row) {
      let dataArray = {
        name: row.name,
        visible: value,
        visibleForAll: row.visibleForAll
      };

      let request = {
        controller: '/Ambito/' + row.id,
        filter: {},
        body: dataArray
      };

      await this.$store
        .dispatch('PF/putSuit', request)
        .then((response) => {})
        .catch((err) => {
          this.showError(err);
        });
    },
    _createAmbito () {
      this.$router.push({ name: 'form_new_ambito' });
    }
  },
  watch: {
    dataGrupos: {
      handler: function () {
        this.data = this.dataGrupos;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-apps {
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
